import { Component, ChangeDetectorRef } from '@angular/core';

import { isObjectEqual } from '@shared/Utils';
import { FormFieldComponent } from '../form-field.types';

@Component({
  templateUrl: './select-form-field.component.html',
  styleUrls: ['./select-form-field.component.scss', './../form-field.component.scss'],
})
export class SelectFormFieldComponent extends FormFieldComponent {
  private _originalValue: string | string[];
  private _value: string | string[];

  public options: any[] = [];
  public multiple: boolean = false;
  public itemKey = 'value';
  public itemLabel = 'label';

  get value(): string | string[] {
    return this._value;
  }

  set value(val: string | string[]) {
    this._value = val;
  }

  constructor(private cdr: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.multiple = this.fieldDef.meta?.multi_select;

    if (!this.fieldDef.meta.option_name) {
      const options = this.fieldDef.meta?.options ?? [];
      this.options = options.map((value) => ({ value: value, label: value }));
    } else {
      this.options = this.data.options[this.fieldDef.meta.option_name];

      if (this.fieldDef.name === 'template_id') {
        this.options = this.options.filter((x) => x.related_to_type === this.fieldDef.related_to_type);
      }

      if (this.fieldDef.meta.option_name == 'pipelines') {
        this.options = this.options.filter((pipeline) => pipeline?.pipeline_type != 'dynamic');
      }

      this.options = this.options.filter((option) => {
        if (option.hidden) {
          return false;
        } else {
          if (option?.pipeline_ids) {
            if (this.model.pipeline_id) {
              return option?.pipeline_ids.includes(Number(this.model.pipeline_id));
            }
          }
        }
        return true;
      });

      this.options = this.options.map((option) => ({
        ...option,
        value: option.id,
        label: option.name || option.full_name,
      }));
    }

    if (this.fieldDef.name !== 'template_id') {
      this.options = this.addNoneOption(this.options);
    }

    let initialValue = this.fieldDef.meta?.value_hidden ? 'REDACTED' : this.model[this.fieldDef.name];

    if (this.multiple && !Array.isArray(initialValue)) {
      initialValue = initialValue ? [initialValue] : [];
    }

    this.value = initialValue;

    this._originalValue = this.value;

    this.cdr.detectChanges();

    setTimeout(() => {
      this.cdr.detectChanges();
    }, 50);
  }

  private onSave(): void {
    if (!isObjectEqual(this._originalValue, this.value)) {
      this.updateModel();
    }
  }

  private updateModel(): void {
    this.model[this.fieldDef.name] = this.value;
    this._originalValue = this.value;
    this.update.emit({ [this.fieldDef.name]: this.value });
  }

  onSelectionChange(newValue: string | string[]): void {
    if (newValue === null || newValue === 'null') {
      this.value = null;
      this.onSave();
      this.cdr.detectChanges();
      return;
    }

    this.value = newValue;
    this.onSave();
    this.cdr.detectChanges();
  }

  private addNoneOption(options: any[]): any[] {
    if (this.multiple) {
      return options;
    }

    return [
      {
        value: null,
        label: 'None',
        id: 'NONE',
        name: 'None',
        isNoneOption: true,
      },
      ...options,
    ];
  }

  updateChangedModel(model: any): void {
    this.model = model;
    this.value = this.model[this.fieldDef.name];

    if (!isObjectEqual(this._originalValue, this.value)) {
      this._originalValue = this.value;
    }

    this.cdr.detectChanges();
  }
}
